import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_autocomplete = _resolveComponent("p-autocomplete")!

  return (_openBlock(), _createBlock(_component_p_autocomplete, _mergeProps(_ctx.$attrs, {
    modelValue: _ctx.place,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.place) = $event)),
    field: (item) => item.description,
    suggestions: _ctx.addressPredictions,
    forceSelection: true,
    onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchAddress($event)))
  }), null, 16, ["modelValue", "field", "suggestions"]))
}